module.exports = __webpack_public_path__ + "img/girl_002.67d73c2b.jpg";